import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Opportunity } from '@vendasta/sales-opportunities';
import { Observable, firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { OpportunityType } from '../../interface';
import { OpportunityServiceModule } from '../../opportunity-service.module';
import { OpportunityService } from '../../opportunity.service';
import { TypeSelectorComponent, getOpportunityTypeFromId } from '../type-selector.component';

@Component({
  standalone: true,
  selector: 'sales-ui-update-type-selector',
  templateUrl: './update-type-selector.component.html',
  imports: [
    MatFormFieldModule,
    CommonModule,
    TranslateModule,
    MatSelectModule,
    TypeSelectorComponent,
    OpportunityServiceModule,
  ],
})
export class UpdateTypeSelectorComponent implements OnInit {
  opportunity$: Observable<Opportunity>;
  initialType$: Observable<OpportunityType>;

  constructor(
    private readonly opportunityUpdates: OpportunityService,
    private readonly snackbarService: SnackbarService,
  ) {}

  ngOnInit(): void {
    this.opportunity$ = this.opportunityUpdates.currentOpportunity$;
    this.initialType$ = this.opportunityUpdates.currentOpportunity$.pipe(
      map((opportunity) => getOpportunityTypeFromId(opportunity.opportunityType)),
    );
  }

  async handleTypeChange(opportunity: Opportunity, typeId: string): Promise<void> {
    const newOpp = await firstValueFrom(this.opportunityUpdates.updateType(opportunity, typeId));
    if (newOpp) {
      this.snackbarService.openSuccessSnack('FRONTEND.SALES_OPPORTUNITIES.OPPORTUNITY_TYPE.SUCCESS');
    } else {
      this.snackbarService.openErrorSnack('FRONTEND.SALES_OPPORTUNITIES.OPPORTUNITY_TYPE.ERROR');
    }
  }
}
